export default "__VITE_ASSET__C1_R5fEs__"